export default "__VITE_ASSET__BIOavaCg__"